import { render, staticRenderFns } from "./HowItWorksModal.vue?vue&type=template&id=3df9fdea&"
import script from "./HowItWorksModal.vue?vue&type=script&lang=js&"
export * from "./HowItWorksModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports